import { render, staticRenderFns } from "./userSendEmail.vue?vue&type=template&id=ec5981e6&scoped=true&"
import script from "./userSendEmail.vue?vue&type=script&lang=js&"
export * from "./userSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./userSendEmail.vue?vue&type=style&index=0&id=ec5981e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5981e6",
  null
  
)

component.options.__file = "userSendEmail.vue"
export default component.exports